import { render, staticRenderFns } from "./StandardInjectionComponent.vue?vue&type=template&id=7258919e&scoped=true&"
import script from "./StandardInjectionComponent.vue?vue&type=script&lang=js&"
export * from "./StandardInjectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./StandardInjectionComponent.vue?vue&type=style&index=0&id=7258919e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7258919e",
  null
  
)

export default component.exports